import BaseFormPresenter from "../../../../../base/BaseFormPresenter";

class WasteComponentFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }
}

export default WasteComponentFormPresenter;
